import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // Initialise les traductions
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { installErrorReporting } from "@/utils/errorReporting";

installErrorReporting();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
